import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useMemo } from 'react';
import { c as cx } from './index-tZvMCc77.js';
import { u as useLayoutPropsUtil } from './useLayoutPropsUtil-GT5myWCm-Cgn7OEq9.js';

import './ThemeProvider-BIeaAmWx.css';function kebabize(str) {
  return str.split("").map((letter, idx) => {
    const prevChar = str[idx - 1];
    if (!isNaN(parseFloat(letter))) {
      if (!isNaN(parseFloat(prevChar))) {
        return letter;
      }
      return `${idx !== 0 ? "-" : ""}${letter.toLowerCase()}`;
    }
    return letter.toUpperCase() === letter ? `${idx !== 0 ? "-" : ""}${letter.toLowerCase()}` : letter;
  }).join("");
}

const themeStyles = {
	"theme-core": "_theme-core_lkxvi_2",
	"mode-light": "_mode-light_lkxvi_405",
	"mode-dark": "_mode-dark_lkxvi_408"
};

const ThemeProviderContext = createContext(
  {}
);
const ThemeProvider = (props) => {
  const { layoutStyles, componentProps } = useLayoutPropsUtil(props);
  const {
    theme,
    mode: modeProp,
    children,
    className: classNameProp,
    style,
    ...rest
  } = componentProps;
  const { mode: modeContext } = useContext(ThemeProviderContext);
  const mode = modeProp ?? modeContext;
  const classNameCombined = cx(themeStyles["theme-provider"], classNameProp, {
    [themeStyles["mode-dark"]]: mode === "dark",
    [themeStyles["mode-light"]]: mode === "light"
  });
  const createCustomThemeStyle = useMemo(() => {
    if (!theme) return;
    const styleObj = {};
    const themeTokens = {
      ...theme.primitive,
      ...theme.semantic,
      ...theme.component
    };
    Object.keys(themeTokens).forEach((token) => {
      const light = themeTokens[token].value;
      const dark = themeTokens[token].attributes?.appearance?.dark.value;
      if (!dark) {
        styleObj[`--${kebabize(token)}`] = light;
        return;
      }
      styleObj[`--${kebabize(token)}`] = `light-dark(${light}, ${dark})`;
    });
    return styleObj;
  }, [theme]);
  const styleCombined = {
    ...style,
    ...layoutStyles,
    ...createCustomThemeStyle
  };
  const value = useMemo(() => ({ theme, mode }), [theme, mode]);
  return /* @__PURE__ */ jsx(ThemeProviderContext.Provider, { value, children: /* @__PURE__ */ jsx("div", { className: classNameCombined, style: styleCombined, ...rest, children }) });
};
ThemeProvider.displayName = "ThemeProvider";

export { ThemeProvider as T, ThemeProviderContext as a, themeStyles as t };
//# sourceMappingURL=ThemeProvider-BIeaAmWx-B782UArj.js.map
